<template>
  <modal name="mail-modal"
         :width="`100%`"
         :height="470"
         :min-width="480"
         :min-height="360"
         :pivotX="0.5"
         :pivotY="0.5"
         :delay="100"
         :clickToClose="false"
         @before-open="beforeOpen"
  >
    <vue-scroll>
      <div class="FloatMenu md_overlay md_overlay_0 ">
      <div class="modal modal_0">
        <div class="md_content">
          <h6 class="--blue70">
            {{ $t('menu.contact_us')}}
          </h6>
          <span class="md_close">
            <img
                src="/images/union.svg"
                alt=""
                @click="modalClose"
            >
          </span>
          <div class="modal_body">
            <KvTable :items="items"/>
          </div>
          <a
              class="btn blue btn_basics pointer no-drag"
              @click="handleClick"
          >
            {{ $t('status.save') }}
          </a>
        </div>
      </div>
    </div>
    </vue-scroll>
  </modal>
</template>
<script>
import {
  _SERVICE_MAIL,
} from "@/static";
import KvTable from "@/components/Table/kvTable";
import _API from "@/api";

export default {
  name: 'mail-modal',
  components: {
    KvTable,
  },
  data() {
    return {
      serviceMail: _SERVICE_MAIL,
      userEmail: localStorage.getItem('userEmail'),
      userName: localStorage.getItem('userName'),
      items: [
        {
          index: 0,
          keyTitle: this.$t('table.header.title'),
          keyType: 'DefaultInput',
          parentClass: [''],
          class: '',
          keyRange: [],
          values: null,
          maxLength: 60,
        },
        {
          index: 1,
          keyTitle: this.$t('table.header.content'),
          keyType: 'textArea',
          parentClass: ['background'],
          class: '',
          keyRange: [],
          values: null,
          maxLength: 4000,
        },
      ],
      loading: false,
    }
  },
  methods: {
    beforeOpen(e) {
    },
    modalClose: function () {
      this.items[0].values = '';
      this.items[1].values = '';

      this.$modal.hide('mail-modal');
    },
    handleClick: function () {
      if (this.loading === false) {
        this.loading = true;
        _API.USER.mailTo({
          boardTitle: this.items[0].values === null || this.items[0].values === '' ? '(no title)' : this.items[0].values,
          boardContext: this.items[1].values === null || this.items[1].values === '' ? '(no message)' : this.items[1].values,
        })
            .then(({data}) => {
              if (data.isSuccess === true) {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.save_completed'
                });
              } else {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.retry_again'
                });
              }
            })
            .finally(() => {
              this.loading = false;
              this.modalClose();
            })
      }
    },
  }
}
</script>
<style lang="scss">
.v--modal-overlay[data-modal="mail-modal"] {
  .md_content {
    height: inherit;
    width: 480px;

    .modal_body {
      .table-container {
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: unset;

        .item-parent {
          grid-column: 1 / 3;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          flex-direction: column;
          -webkit-box-align: unset;
          align-items: unset;

          .item-title {
            -webkit-box-flex: 2;
            flex: 2 2 2rem;
          }

          .item-value {
            textarea {
              height: 150px;
            }
          }
        }
      }
    }
  }
}
</style>